import APIKeysService from '@/api/client/apiKeys.service'
import AccountsService from '@/api/client/accounts.service'

export default {
  state: {
    table: {
      pageLength: 10,
      rows: [],
      totalRecords: 0,
      searchTerm: '',
    },
    apiKeyModel: {},
    userRoles: {},
  },
  getters: {
    apiKeys: state => state.table,
    getApiKeyModel: state => state.apiKeyModel,
    getUserRoles: state => state.userRoles,
  },
  actions: {
    async getAPIKeys({ commit }, wrapper) {
      const APIKeys = await APIKeysService.getAPIKeys(wrapper.accountId, wrapper.page || 0, wrapper.searchTerm || '')
      const userRoles = await AccountsService.getUserRoles(wrapper.accountId)
      commit('SET_API_KEYS', APIKeys.keys)
      commit('SET_USER_ROLES', userRoles)
      commit('SET_TOTALRECORDS', APIKeys.totalRows)
    },
  },
  mutations: {
    SET_API_KEYS(state, APIKeys) {
      state.table.rows = APIKeys
    },
    SET_USER_ROLES(state, userRoles) {
      state.userRoles = userRoles
    },
    SET_TOTALRECORDS(state, totalRecords) {
      state.table.totalRecords = totalRecords
    },
    SET_API_KEY_MODEL(state, APIKey) {
      state.apiKeyModel = APIKey
    },
  },
}
